import React, { useState } from "react";
import "./Tasks.css";
import Circleradialchart from "../circleradialchart/Circleradialchart";
import Hometabs from "../hometabs/Hometabs";
import UpcomingMeetingsOwner from "../OwnerhomeNew/OwnerHomeNewComponents/UpcomingMeetingsOwner";
import WeeklySupervisionCard from "./WeeklySupervisionCard";
import ActionItemsGrid from "./ActionItemsGrid";
import { useAuth } from "../../../firebase/AuthProvider";
import AuditSection from "../ownerhome/AuditSection";
import { ROLES } from "../../../Data/SD";
import TaskProgress from "./TaskProgress";
import "./TaskSection.css";
import ParticipantEngagementRisk from "../dashboard/ParticipantEngagementRisk";
import LogActivityModal from "../TasksPage/LogActivityModal";
import ModalMeet from "../calendar/ModalMeet";

type TaskSectionProps = {
  userId?: string | null;
  isLoading: boolean;
};

const TaskSection: React.FC<TaskSectionProps> = ({ userId, isLoading }) => {
  const { currentRoles } = useAuth();
  const [isLogActivityModalOpen, setIsLogActivityModalOpen] = useState(false);
  const [selectedParticipantId, setSelectedParticipantId] = useState<number | null>(null);

  const handleLogActivityClick = (participantId: number) => {
    setSelectedParticipantId(participantId);
    setIsLogActivityModalOpen(true);
  };

  return (
    <>
      <div className="lg:flex w-[100%] gap-6" style={{ alignItems: "start" }}>
        {/* LEFT SECTION */}
        <div className="space-y-6 lg:w-[100%] xl:w-[59%] 2xl:w-[64%]">
          <div className="gridlayout">
            <TaskProgress />
            <ActionItemsGrid />
          </div>
          <Hometabs />
        </div>

        {/* RIGHT SECTION */}
        <div className="space-y-6 lg:w-[48%] xl:w-[41%] 2xl:w-[36%] mt-6 lg:mt-0">
          <UpcomingMeetingsOwner />
          <ParticipantEngagementRisk
            onLogActivityClick={handleLogActivityClick}
          />
        </div>
      </div>

      <div>
        {isLoading && (
          <div className="absolute flex justify-center align-middle items-center w-full h-full">
             {/* ... Loading Spinner Content ... */}
             <div className="absolute  bg-gray-200 opacity-50 w-full h-full z-10"></div>
             {/* ... (Spinner SVG omitted for brevity, keeping existing) ... */}
          </div>
        )}
      </div>

      {/* Log Activity Modal */}
      <ModalMeet
        isOpen={isLogActivityModalOpen}
        onClose={() => {
          setIsLogActivityModalOpen(false);
          setSelectedParticipantId(null);
        }}
        widthClass="max-w-[600px]"
        allowOverflow={false}
      >
        <LogActivityModal
          onClose={() => {
            setIsLogActivityModalOpen(false);
            setSelectedParticipantId(null);
          }}
          // PASS THE SELECTED PARTICIPANT ID HERE
          selectedParticipantId={selectedParticipantId}
          onActivityCreated={() => {
            setIsLogActivityModalOpen(false);
            setSelectedParticipantId(null);
          }}
        />
      </ModalMeet>
    </>
  );
};

export default TaskSection;